<div class="spinner-container" *ngIf="!dataReady && !videoNotExist">
	<mat-spinner class="custom-spinner"></mat-spinner>
  </div>
<div *ngIf="domainIsWrong">
	<p>Not allowed to display on this domain</p>
</div>
<div *ngIf="videoNotExist">
	<p>Video with such ID not exist</p>
</div>
<div class="screen" *ngIf="dataReady && !domainIsWrong && !videoNotExist" [style]="'background-color: ' + data.videoData.bgColor + ';'">
	<app-video-player *ngIf="data.videoData.type==='video'" [videoData]="data.videoData"></app-video-player>
	<app-audio-player *ngIf="data.videoData.type==='audio'" [mediaData]="data.videoData"></app-audio-player>
</div>
